const DrawerButton = ({
    isOpen,
    handleClick
})=>{
    return (
        <span className="toggleImage">
            <img
              src="https://cdn-icons-png.flaticon.com/128/4655/4655143.png"
              alt="minus"
              style={{ width: "20px", height: "35px",cursor:'pointer' }}
              className={isOpen ? "closed" : "open"}
              onClick={() => handleClick()}
            />
          </span>
    )
}

export default DrawerButton